class PopupVideoControls {
    constructor(wrapper) {
        this.activeClass = 'is-active';
        this.buttonActiveClass = 'button_theme_color';
        this.buttonStateClass = 'button_theme_stroke';
        this.wrapper = wrapper;
        this.controls = wrapper.querySelectorAll('.j-online-video-btn');
        this.videoWrappers = Array.from(wrapper.querySelectorAll('.j-video'));
        this.descriptions = Array.from(wrapper.querySelectorAll('.j-video-description'));
    }

    /**
     * Инициализация экземпляра класса
     * @public
     */
    init() {
        this._bindEvents();
    }

    /**
     * Бинд событий
     * @private
     */
    _bindEvents() {
        this.controls.forEach((control) => {
            control.addEventListener('click', this._toggleVideoContent.bind(this));
        });
    }

    /**
     * Показывает видео
     * @param {object} event - объект события
     * @private
     */
    _toggleVideoContent(event) {
        const targetId = event.currentTarget.dataset.video;

        this._toggleControls(targetId);
        this._toggleVideo(targetId);
        this._toggleDescription(targetId);
    }

    /**
     * Переключает состояние кнопок
     * @param {string} targetId - идентификатор
     * @private
     */
    _toggleControls(targetId) {
        this.controls.forEach((control) => {
            const classOrder =
                control.dataset.video === targetId ?
                    [this.buttonStateClass, this.buttonActiveClass] :
                    [this.buttonActiveClass, this.buttonStateClass];

            control.classList.remove(classOrder[0]);
            control.classList.add(classOrder[1]);
        });
    }

    /**
     * Переключает состояние видео
     * @param {string} targetId - идентификатор
     * @private
     */
    _toggleVideo(targetId) {
        this.videoWrappers.forEach((wrapper) => {
            if (wrapper.dataset.video === targetId) {
                wrapper.classList.add(this.activeClass);
            } else {
                const video = wrapper.querySelector('iframe');

                wrapper.classList.remove(this.activeClass);
                // предотвращает дальнейшее воспроизведение
                video.setAttribute('src', video.getAttribute('src'));
            }
        });
    }

    /**
     * Переключает состояние описания
     * @param {string} targetId - идентификатор
     * @private
     */
    _toggleDescription(targetId) {
        this.descriptions.forEach((description) => {
            // eslint-disable-next-line no-unused-expressions
            description.dataset.video === targetId ?
                description.classList.add(this.activeClass) :
                description.classList.remove(this.activeClass);
        });
    }
}

export default PopupVideoControls;

